export const SESSION_LAST_ACTIVITY_KEY = "session-last-activity";
export const SESSION_LOGOUT_SIGNAL_KEY = "session-logout-signal";
